import { queryClient } from 'App';

export default () => {
  queryClient.invalidateQueries({
    queryKey: ['appointment-events'],
    exact: false
  });
};
